























































import { Vue, Component } from 'vue-property-decorator';
import { SwipeItem, Swipe, Icon, ImagePreview } from 'vant';
import { getDetail } from '../api';
import { isWeiXin } from '@/common/ts/common';
import VoteButton from '@/components/VoteButton.vue';

Vue.use(Swipe)
  .use(SwipeItem)
  .use(Icon)
  .use(ImagePreview);

@Component({
  components: {
    VoteButton,
  },
})
export default class Detail extends Vue {
  detail: any = {};
  activeTab = 0;
  tabbar: any[] = [
    { title: '作品展示', id: 1, scrollPos: 0 },
    { title: '新闻链接', id: 2, scrollPos: 0 },
    { title: '活动简介', id: 3, scrollPos: 0 },
  ];

  async created() {
    const ret = await getDetail(this.$route.query.id);
    this.detail = ret.data;
    // 设置pv和分享
    const cover =
      'https://image2.cqcb.com/d/file/topics/activity/2020-07-16/H7zAX2J7-1594879480279.jpg';
    this.$appShareInfo({
      title: '2020重庆·渝中文创产品设计大赛',
      url: location.href,
      subtitle: `我是${this.detail.id}号，我正在参加2020重庆·渝中文创产品设计大赛，请为我点赞`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '2020重庆·渝中文创产品设计大赛',
        subtitle: `我是${this.detail.id}号，我正在参加2020重庆·渝中文创产品设计大赛，请为我点赞`,
        image: cover,
      });
    }
  }
  onSliderClick(index: number) {
    ImagePreview({
      images: this.detail.img_url_list,
      startPosition: index,
    });
  }
  updateZan() {
    this.$emit('updateVote');
    this.detail.votes = Number(this.detail.votes) + 1;
  }
  onTabChange(index: number) {
    // if(index === 0) {
    //   return this.$router.back();
    // }
    this.$router.push(
      `/2020-cq-yuzhong-cultural-and-creative-product-design-competition/home/${index +
        1}`,
    );
  }
}
